export default __webpack_public_path__ + "static/media/Canadian Olympic Committee - Logo.c871c28e.png";